// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditPassword_modalOverlay__tLNNg","modal":"EditPassword_modal__PP5MN","modalClose":"EditPassword_modalClose__K1Rcn","modalButtons":"EditPassword_modalButtons__4ztKi"};